import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { NewsletterEndpoint } from '../constants/newsletter-endpoint';

@Injectable({
  providedIn: 'root',
})
export class NewsletterItemFileService {
  constructor(private http: WrapperHttpService) {}

  getNewsletterItemFile(newsletterItemFileId: string): Observable<string> {
    return this.http
      .withLoading()
      .get<string>(`${API_URL}${NewsletterEndpoint.Base}/${newsletterItemFileId}${NewsletterEndpoint.Content}`, {
        responseType: 'text',
      });
  }
}
